var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectPlans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 133,
    viewBox: "0 0 172 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M164.452 69.9609C164.452 69.9609 150.873 57.9687 149.146 56.657C147.42 55.3452 126.038 42.7567 120.267 37.7794C115.378 34.0878 113.429 29.629 111.79 27.1714C110.022 24.522 106.087 22.754 105.89 20.8408C105.797 19.975 106.6 19.5654 107.674 19.441C106.528 19.441 108.545 19.3476 108.104 19.4099C109.286 19.3736 110.463 19.5498 111.588 19.9283C113.278 20.5557 118.328 23.7184 119.365 24.4805H119.427C120.76 25.2375 122.943 26.9951 123.446 23.4902C123.949 19.9854 119.137 16.2679 119.137 16.2679C119.137 16.2679 110.463 16.7605 109.182 16.6827C106.237 16.496 107.109 13.0534 107.109 13.0534L114.03 10.9432C112.361 10.4559 108.514 9.10265 109.022 7.05987C109.38 5.63926 123.477 6.84728 123.477 6.84728C123.477 6.84728 124.125 7.19468 125.032 7.71315C125.105 5.7274 125.265 1.75073 125.411 0.853771C125.597 -0.359454 127.821 0.0760626 127.821 0.0760626L133.317 16.5376C133.722 17.7871 134.567 20.0165 135.225 21.7223C136.433 23.734 137.273 25.9478 137.714 28.255L172.001 45.7639",
    fill: "#FFC89E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M114.012 10.8636C114.012 10.8636 121.493 8.55633 122.23 9.22516C122.966 9.89399 129.395 14.8921 129.395 14.8921",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M124.98 7.5918C124.98 7.5918 128.854 9.90936 131.036 12.3825",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M111.346 17.5781H67.1931C66.4725 17.5781 65.7622 17.7752 65.14 18.1381C64.5178 18.501 64.0046 19.0247 63.6469 19.652L55.5379 33.6975C55.1801 34.3196 54.9883 35.0247 54.9883 35.7454C54.9883 36.4661 55.1801 37.1713 55.5379 37.7934L63.6469 51.8388C64.0046 52.461 64.523 52.9795 65.1452 53.3372C65.7674 53.695 66.4725 53.8868 67.1931 53.8868H111.346C111.886 53.8868 112.414 53.7831 112.912 53.5757C113.41 53.3683 113.861 53.0676 114.239 52.6891C114.623 52.3106 114.924 51.8595 115.131 51.3618C115.333 50.8641 115.442 50.3352 115.442 49.796V21.6793C115.442 21.14 115.333 20.606 115.131 20.1135C114.924 19.6157 114.623 19.1647 114.239 18.7862C113.861 18.4077 113.41 18.1018 112.912 17.8996C112.414 17.6922 111.886 17.5885 111.346 17.5885V17.5781Z",
    fill: "#FF7B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.3164 42.3141L94.844 27.7812",
    stroke: "black",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M84.6821 30.6376C85.9731 30.6376 87.0204 29.5903 87.0204 28.2993C87.0204 27.0083 85.9731 25.9609 84.6821 25.9609C83.3911 25.9609 82.3438 27.0083 82.3438 28.2993C82.3438 29.5903 83.3911 30.6376 84.6821 30.6376Z",
    stroke: "black",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M91.3852 43.2821C92.6762 43.2821 93.7235 42.2348 93.7235 40.9438C93.7235 39.6528 92.6762 38.6055 91.3852 38.6055C90.0942 38.6055 89.0469 39.6528 89.0469 40.9438C89.0469 42.2348 90.0942 43.2821 91.3852 43.2821Z",
    stroke: "black",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.3083 82.3936C23.589 81.4707 24.771 80.4131 25.8338 79.2465C27.213 77.6393 45.4839 60.7785 50.0776 54.6917C54.0698 50.0254 55.0343 45.2814 56.1179 42.5283C57.2845 39.5678 60.7531 37.0066 60.5509 35.0986C60.4575 34.2276 59.5812 34.0046 58.508 34.1083C59.6331 33.8853 57.637 34.2017 58.0829 34.1654C56.9164 34.3676 55.7964 34.7823 54.7802 35.389C53.2611 36.3637 49.0097 40.5166 48.1127 41.4913C48.0972 41.4913 48.0764 41.4913 48.0608 41.4913C46.915 42.5283 45.1574 44.6903 43.913 41.3721C42.6687 38.0539 46.635 33.4291 46.635 33.4291C46.635 33.4291 55.2157 32.0759 56.4497 31.7285C59.2857 30.9249 57.7148 27.7674 57.7148 27.7674L50.5028 27.166C52.0582 26.3364 55.5061 24.1951 54.5729 22.3078C53.8937 21.022 40.377 25.1698 40.377 25.1698C40.377 25.1698 39.817 25.6416 39.0549 26.3364C38.5364 24.4129 37.5669 20.5607 37.2402 19.7104C36.784 18.5594 34.7101 19.4666 34.7101 19.4666L32.8178 36.7162C32.683 38.0228 32.3304 40.3767 32.0504 42.1861C31.3038 44.4104 30.9513 46.7487 31.0135 49.0973L9.09766 66.7254L22.3083 82.3936Z",
    fill: "#FFC89E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M50.4941 27.0657C50.4941 27.0657 42.6911 26.3969 42.1104 27.2005C41.5297 28.0041 36.3086 34.2569 36.3086 34.2569",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.0375 26.1738C39.0375 26.1738 35.7453 29.2847 34.1328 32.1363",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M121.498 25.517C120.777 25.2526 120.093 24.9052 119.455 24.4801H119.393C118.314 23.7179 113.28 20.5552 111.616 19.9279C110.496 19.5494 109.314 19.3731 108.131 19.4094C108.572 19.3472 106.576 19.4613 107.701 19.4405C106.628 19.565 105.824 19.959 105.918 20.8404C106.12 22.7536 110.065 24.5215 111.818 27.1709C112.855 28.7263 114.042 31.1269 116.023 33.6052",
    fill: "#FFC89E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M125.802 95.9062C127.119 91.0067 124.21 85.9723 119.316 84.6606C114.416 83.3437 109.382 86.2523 108.065 91.1518C106.753 96.0462 109.657 101.086 114.556 102.398C119.456 103.709 124.49 100.806 125.802 95.9062Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M125.248 94.2403C119.001 89.8489 111.753 87.0958 104.167 86.2352L9.09708 66.4922L7.5417 67.7987C-4.50735 77.8413 0.00850499 97.3251 15.2461 101.042L78.3117 116.436L77.1815 132.871H170.691L168.846 118.872C168.229 114.175 166.16 109.789 162.94 106.32C159.716 102.852 155.49 100.472 150.855 99.513L125.248 94.2403Z",
    fill: "#01304A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M151.779 50.5431C153.744 45.462 150.364 39.4166 144.225 37.0472C138.091 34.6778 131.527 36.8761 129.562 41.9623C127.597 47.0433 130.983 53.0887 137.117 55.4582C143.25 57.8276 149.819 55.6293 151.779 50.5431Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M159.372 62.0426C154.773 44.0049 137.964 45.7522 134.827 47.2039C134.091 47.5513 133.381 47.8779 132.686 48.1838C131.483 48.5623 130.316 49.0445 129.196 49.6252C126.661 50.5377 124.53 50.885 122.933 50.071C121.798 49.4955 118.075 52.5494 115.529 56.9668C117.909 57.7859 120.382 58.294 122.892 58.4807C120.222 60.1761 117.043 60.8812 113.907 60.4768C112.315 65.0394 112.512 70.2759 117.458 74.4393C119.257 76.3006 121.378 77.83 123.711 78.9499L118.288 89.4127L136.88 97.1536L143.346 87.8211C143.719 87.7329 144.092 87.6448 144.465 87.5411C149.801 86.0945 154.347 82.6104 157.137 77.8405C159.926 73.0705 160.73 67.3984 159.372 62.0426Z",
    fill: "#FFC89E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M160.696 51.5433C158.342 48.785 155.345 46.6437 151.97 45.3216C148.59 43.9995 144.94 43.5277 141.336 43.9477C143.052 45.1195 144.603 46.5141 145.945 48.0955C155.236 59.0923 152.732 76.487 140.356 86.9446C139.667 87.5253 138.962 88.0645 138.246 88.5778C141.642 89.1948 145.126 89.0548 148.46 88.1578C151.789 87.2608 154.879 85.6329 157.497 83.3931C167.198 75.2168 168.629 60.9484 160.696 51.5433Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M140.484 42.1016C140.484 42.1016 139.966 48.3232 143.595 52.8702C145.518 55.2656 140.94 52.9791 140.168 56.0641C134.376 79.1879 134.522 84.0616 134.522 84.0616C134.366 85.0622 134.532 86.0836 134.999 86.9858C135.465 87.8827 136.207 88.6086 137.114 89.0545L142.744 91.8023L146.633 87.1672L158.491 65.3032C158.491 65.3032 153.223 43.4444 140.484 42.1016Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M135.457 48.375C138.008 49.8682 137.396 53.4405 136.214 54.3219",
    stroke: "#080717",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M130.675 53.445C130.048 53.5435 129.483 53.2583 129.41 52.8072C129.337 52.3562 129.789 51.9051 130.416 51.8066C131.043 51.7081 131.614 51.9932 131.681 52.4443C131.748 52.8953 131.303 53.3464 130.675 53.445Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M141.702 54.3594C141.702 54.3594 131.504 57.0865 130.897 61.618C130.29 66.1494 137.264 69.7943 133.681 76.607C130.099 83.4198 131.41 86.0121 122.601 83.119C110.848 79.2564 104.543 79.6245 101.443 85.8254C101.189 86.3439 106.342 86.6395 112.398 88.2157C120.476 90.3206 129.404 97.0608 129.404 97.0608C129.404 97.0608 143.553 90.5228 141.702 54.3594Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M128.952 69.2445C128.517 70.3696 128.429 71.5932 128.688 72.7702C128.952 73.9471 129.559 75.0151 130.435 75.8499C131.306 76.6794 132.405 77.2342 133.593 77.4416C134.78 77.6438 135.999 77.4935 137.103 77.0061C138.202 76.5187 139.135 75.7151 139.778 74.6989C140.426 73.6827 140.753 72.4954 140.727 71.2925C140.696 70.0897 140.312 68.9179 139.617 67.9328C138.923 66.9477 137.953 66.1907 136.833 65.7552C135.324 65.1745 133.645 65.216 132.167 65.8693C130.689 66.5225 129.533 67.7358 128.952 69.2445Z",
    fill: "#FFC89E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M136.873 69.796C136.873 69.796 132.497 69.459 131.59 71.8129",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M163.748 102.715C165.811 97.3328 163.126 91.303 157.744 89.2394C152.367 87.1759 146.332 89.8668 144.269 95.2433C142.205 100.625 144.896 106.655 150.273 108.718C155.654 110.782 161.689 108.091 163.748 102.715Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M152.093 44.6656C158.657 43.9604 175.652 57.197 165.936 75.9346C161.109 85.2671 153.207 99.0325 154.27 105.161C155.333 111.289 156.303 107.598 150.952 110.102C145.602 112.606 131.074 105.705 129.41 101.63C127.745 97.5549 119.559 97.2853 137.337 83.3695C155.116 69.4537 147.447 56.2119 146.54 55.0972C145.633 53.9825 142.47 45.7025 152.093 44.6656Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M147.462 104.61C151.968 99.0256 151.097 90.8492 145.513 86.3437C139.929 81.833 131.747 82.7092 127.242 88.2931C122.736 93.8771 123.607 102.059 129.191 106.564C134.775 111.07 142.957 110.199 147.462 104.61Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M160.534 108.588C162.976 102.372 159.917 95.3517 153.701 92.9149C147.484 90.4729 140.47 93.5319 138.028 99.7484C135.586 105.965 138.65 112.98 144.861 115.422C151.077 117.864 158.098 114.805 160.534 108.588Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M89.2575 118.701L78.2969 116.436",
    stroke: "black",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPlans);
export default __webpack_public_path__ + "static/media/SelectPlans.43e411ceab2bef16394e25505b47c6df.svg";
export { ForwardRef as ReactComponent };